import React, { memo, useCallback } from 'react';

import { Button } from '@ergeon/core-components';
import { PhoneArrowDownLeftIcon, PhoneXMarkIcon } from '@ergeon/icons/hero/micro';

import { IncomingCallControlsProps } from './types';

const IncomingCallControls: React.FC<IncomingCallControlsProps> = memo(({ loadingStates, onAccept, onDecline }) => {
  const handleAccept = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      onAccept();
    },
    [onAccept],
  );

  const handleDecline = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      onDecline();
    },
    [onDecline],
  );

  return (
    <div className="flex items-center gap-1">
      <Button
        aria-label="Accept incoming call"
        data-testid="accept-call-button"
        disabled={loadingStates.accept}
        flavor="success"
        isSquare
        onClick={handleAccept}
        size="medium"
        title="Accept call">
        <PhoneArrowDownLeftIcon className="size-4 shrink-0" data-testid="accept-call-icon" />
      </Button>
      <Button
        aria-label="Decline incoming call"
        data-testid="decline-call-button"
        disabled={loadingStates.decline}
        flavor="danger"
        isSquare
        onClick={handleDecline}
        size="medium"
        title="Decline call">
        <PhoneXMarkIcon className="size-4 shrink-0" data-testid="decline-call-icon" />
      </Button>
    </div>
  );
});

IncomingCallControls.displayName = 'IncomingCallControls';

export default IncomingCallControls;
